<template>
  <div class="text-center">
    <div class="styleMenuv" v-for="(option, index) in options" v-bind:key="index">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn small link class="ma-2" dark v-bind="attrs" v-on="on" :to="option.href">
            <i v-if="option.icon" v-bind:class="option.icon"></i>
            {{ $tc(option.lang) }}
          </v-btn>
        </template>
        <v-list v-if="option.items.length > 0">
          <v-list-item
            v-for="(item, index) in option.items"
            v-bind:key="index"
            :to="item.href"
          >
            <v-list-item-title>{{ $tc(item.lang) }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    options: function () {
      const options = [
        {
          icon: "far fa-tachometer",
          lang: "top-menu.all.dashboard",
          name: null,
          href: "/dashBoard",
          items: []
        },
        {
          icon: "far fa-dollar-sign",
          lang: "top-menu.eventsDetails.pricing",
          name: null,
          href: `/dashBoard/eventDetails/${this.$route.params.id}/pricing`,
          items: [],
        },
        {
          icon: "far fa-dollar-sign",
          lang: "top-menu.eventsDetails.practice",
          name: null,
          href: `/eventDetails/${this.$route.params.id}/practice`,
          items: [],
        },
        {
          icon: "far fa-clipboard",
          lang: "top-menu.eventsDetails.registrations",
          name: null,
          items: [
            {
              lang: "top-menu.registration.registration.registration-configuration",
              href: `/dashBoard/eventDetails/${this.$route.params.id}/registerConfiguration`,
              name: 'RegistrationSetup'
            },
            {
              lang: "top-menu.registration.registration.registrant",
              href: `/dashBoard/eventDetails/${this.$route.params.id}/registration`,
              name: 'Registration'
            },
            {
              lang: "top-menu.registration.registration.registered-spectator",
              href: `/dashBoard/eventDetails/${this.$route.params.id}/registeredSpectator`,
              name: 'RegisteredSpectator'
            },
            {
              lang: "top-menu.registration.registration.newRegistrant",
              href: `/dashBoard/eventDetails/${this.$route.params.id}/createregistrant`,
              name: 'CreateRegistrant'
            },
            {
              lang: "top-menu.registration.registration.importRegistrant",
              href: `/dashBoard/eventDetails/${this.$route.params.id}/importregistrants`,
              name: 'ImportRegistrants'
            },
            {
              lang: "top-menu.registration.registration.deleteAllRegistrant",
              href: `/dashBoard/eventDetails/${this.$route.params.id}/deletedallregistrant`,
              name: 'ImportRegistrants'
            },
            {
              lang: "top-menu.eventsDetails.waitList",
              href: `/dashBoard/eventDetails/${this.$route.params.id}/waitList`,
              name: 'WaitList'
            },
            {
              lang: "top-menu.registration.registration.validateama",
              href: `/dashBoard/eventDetails/${this.$route.params.id}/validateama`,
              name: 'ValidateAma'
            },
          ],
        },
        {
          icon: "far fa-flag-checkered",
          lang: "top-menu.eventsDetails.races",
          name: null,
          items: [
            {
              lang: "top-menu.eventsDetails.race-list",
              href: `/dashBoard/eventDetails/${this.$route.params.id}/raceList`,
              name: 'EventRaceList'
            },
            {
              lang: "top-menu.eventsDetails.race-images",
              href: `/dashBoard/eventDetails/${this.$route.params.id}/raceImages`,
              name: 'EventRaceImages'
            },
            {
              lang: "top-menu.eventsDetails.advance-settings",
              href: `/dashBoard/eventDetails/${this.$route.params.id}/raceAdvanceSettings`,
              name: 'EventRaceAdvanceSettings'
            }
          ]
        },
        {
          icon: "far fa-tags",
          lang: "top-menu.eventsDetails.classes",
          name: null,
          items: [
            {
              lang: "top-menu.eventsDetails.class-list",
              href: `/dashBoard/eventDetails/${this.$route.params.id}/eventClasses`,
              name: 'EventClasses'
            },
            {
              lang: "top-menu.eventsDetails.division",
              href: `/eventDetails/${this.$route.params.id}/divisions`,
              name: 'RegisteredSpectator'
            },
            {
              lang: "top-menu.eventsDetails.linked-class",
              href: `/dashBoard/eventDetails/${this.$route.params.id}/linkedClasses`,
              name: 'LinkedClasses'
            },
            {
              lang: "top-menu.eventsDetails.create-new-class",
              href: `/dashBoard/eventDetails/${this.$route.params.id}/eventClasses/create`,
              name: 'CreateClasses'
            },
            {
              lang: "top-menu.eventsDetails.import-class",
              href: `/dashBoard/eventDetails/${this.$route.params.id}/importClasses`,
              name: 'ImportClasses'
            },
          ],
        },
        {
          icon: "fab fa-delicious",
          lang: "top-menu.eventsDetails.brands",
          name: null,
          items: [
            {
              lang: "top-menu.eventsDetails.brands_list",
              href: `/dashBoard/eventDetails/${this.$route.params.id}/eventBrands`,
              name: 'EventBrands'
            },
            {
              lang: "top-menu.eventsDetails.brands_import",
              href: `/dashBoard/eventDetails/${this.$route.params.id}/importBrands`,
              name: 'ImportBrands'
            },
          ],
        },
        {
          icon: "far fa-users",
          lang: "top-menu.eventsDetails.teams",
          href: "",
          name: null,
          items: [],
        },
        {
          icon: "far fa-flag-checkered",
          lang: "top-menu.eventsDetails.startGrids",
          href: "",
          name: null,
          items: [
            {
              lang: "top-menu.eventsDetails.startGrids",
              href: `/dashBoard/eventDetails/${this.$route.params.id}/startGrids`,
              name: 'StartGrids'
            },
          ],
        },
        {
          icon: "far fa-copy",
          lang: "top-menu.eventsDetails.cloneEvents",
          href: "",
          name: null,
          items: [
            {
              lang: "top-menu.registration.export.myLaps",
              href: `/dashBoard/eventDetails/${this.$route.params.id}/myLaps`,
              name: 'MyLaps'
            },
            {
              lang: "top-menu.registration.export.sportsTags",
              href: `/dashBoard/eventDetails/${this.$route.params.id}/sportTags`,
              name: 'SportTags'
            },
            {
              lang: "top-menu.registration.export.raceTimer",
              href: `/dashBoard/eventDetails/${this.$route.params.id}/raceTimer`,
              name: 'RaceTimer'
            },
            {
              lang: "top-menu.registration.export.westHold",
              href: `/dashBoard/eventDetails/${this.$route.params.id}/westhold`,
              name: 'Westhold'
            },
          ],
        }
      ];
      this.generateTopMenu(options);
      return options;
    }
  },
  methods: {
    generateTopMenu: function (items) {
      let options = [];
      options = items.map((elem) => {
        const subitems = elem.items.map((elem1) => {
          return {
            ...elem1,
            text: this.$t(elem1.lang)
          };
        });
        return {
          ...elem,
          text: this.$t(elem.lang),
          items: subitems
        };
      });
      this.$emit("loadTopMenuResponsive", options);
    }
  }
};
</script>

<style scoped>
.legacy-dashboard {
  text-align: right !important;
  text-align: -moz-right !important;
  text-decoration: underline !important;
  color: #0e152d !important;
  margin-right: 10px;
}
.styleMenuv {
  display: inline;
}
</style>
